// extracted by mini-css-extract-plugin
module.exports = {"containerMain":"about-module--containerMain--bec1t","containerTeamCard":"about-module--containerTeamCard--6jMoz"};